import { SbefCodeRecord, SbefCode } from './sbef.model';

export const sbefCodeRecord: SbefCodeRecord = {
  '0': {
    code: '0',
    name: 'Demolition, remediation',
  },
  '00': {
    code: '00',
    name: 'Combined',
  },
  '01': {
    code: '01',
    name: 'Dismantling',
  },
  '02': {
    code: '02',
    name: 'Remediation, light demolition',
  },
  '03': {
    code: '03',
    name: 'Heavy demolition',
  },
  '04': {
    code: '04',
    name: 'Patching',
  },
  '05': {
    code: '05',
    name: '',
  },
  '06': {
    code: '06',
    name: 'Openings',
  },
  '07': {
    code: '07',
    name: 'Works for installations',
  },
  '08': {
    code: '08',
    name: '',
  },
  '09': {
    code: '09',
    name: '',
  },
  '1': {
    code: '1',
    name: 'Groundworks',
  },
  '10': {
    code: '10',
    name: 'Combined',
  },
  '11': {
    code: '11',
    name: 'Clearing, demolition, relocation',
  },
  '12': {
    code: '12',
    name: 'Excavation, filling',
  },
  '13': {
    code: '13',
    name: 'Ground reinforcement, drainage',
  },
  '14': {
    code: '14',
    name: '',
  },
  '15': {
    code: '15',
    name: 'Utilities, culverts, tunnels',
  },
  '16': {
    code: '16',
    name: 'Roads, paved areas',
  },
  '17': {
    code: '17',
    name: 'Landscaping',
  },
  '18': {
    code: '18',
    name: 'Site equipment retaining walls, ancillary buildings',
  },
  '19': {
    code: '19',
    name: 'Other groundworks',
  },
  '2': {
    code: '2',
    name: 'Substructure',
    lifetime: 60,
  },
  '20': {
    code: '20',
    name: 'Combined',
    lifetime: 60,
  },
  '21': {
    code: '21',
    name: '',
  },
  '22': {
    code: '22',
    name: 'Excavation, filling',
    lifetime: 60,
  },
  '23': {
    code: '23',
    name: 'Ground reinforcement, drainage',
    lifetime: 60,
  },
  '24': {
    code: '24',
    name: 'Foundation structures',
    lifetime: 60,
  },
  '25': {
    code: '25',
    name: 'Culverts, tunnels',
    lifetime: 60,
  },
  '26': {
    code: '26',
    name: 'Garage',
    lifetime: 60,
  },
  '27': {
    code: '27',
    name: 'Slab on ground',
    lifetime: 60,
  },
  '28': {
    code: '28',
    name: 'Substructure completions',
    lifetime: 60,
  },
  '29': {
    code: '29',
    name: 'Other substructure',
    lifetime: 60,
  },
  '3': {
    code: '3',
    name: 'Frame',
    lifetime: 60,
  },
  '30': {
    code: '30',
    name: 'Combined',
    lifetime: 60,
  },
  '31': {
    code: '31',
    name: 'Frame walls',
    lifetime: 60,
  },
  '32': {
    code: '32',
    name: 'Pillars',
    lifetime: 60,
  },
  '33': {
    code: '33',
    name: 'Prefab structure',
    lifetime: 60,
  },
  '34': {
    code: '34',
    name: 'Floor slabs, beams',
    lifetime: 60,
  },
  '35': {
    code: '35',
    name: 'Steelwork',
    lifetime: 60,
  },
  '36': {
    code: '36',
    name: 'Stairs, lift shafts',
    lifetime: 60,
  },
  '37': {
    code: '37',
    name: 'Composite roof structure',
    lifetime: 60,
  },
  '38': {
    code: '38',
    name: 'Frame completions',
    lifetime: 60,
  },
  '39': {
    code: '39',
    name: 'Other frame',
    lifetime: 60,
  },
  '4': {
    code: '4',
    name: 'Roof',
    lifetime: 30,
  },
  '40': {
    code: '40',
    name: 'Combined',
    lifetime: 30,
  },
  '41': {
    code: '41',
    name: 'Roof structure',
    lifetime: 60,
  },
  '42': {
    code: '42',
    name: 'Roof build-up completions',
    lifetime: 30,
  },
  '43': {
    code: '43',
    name: 'Roof covering',
    lifetime: 30,
  },
  '44': {
    code: '44',
    name: 'Eaves, gables',
    lifetime: 30,
  },
  '45': {
    code: '45',
    name: 'Roof openings & accessories',
    lifetime: 30,
  },
  '46': {
    code: '46',
    name: 'Sheet metal works',
    lifetime: 30,
  },
  '47': {
    code: '47',
    name: 'Terrace roofs, decks',
    lifetime: 30,
  },
  '48': {
    code: '48',
    name: 'Roof completions',
    lifetime: 30,
  },
  '49': {
    code: '49',
    name: 'Other roof',
    lifetime: 30,
  },
  '5': {
    code: '5',
    name: 'Facades',
    lifetime: 30,
  },
  '50': {
    code: '50',
    name: 'Combined',
    lifetime: 30,
  },
  '51': {
    code: '51',
    name: 'Frame complementation / filling',
    lifetime: 30,
  },
  '52': {
    code: '52',
    name: '',
  },
  '53': {
    code: '53',
    name: 'Facade cladding',
    lifetime: 30,
  },
  '54': {
    code: '54',
    name: '',
  },
  '55': {
    code: '55',
    name: 'Windows, doors, glazed partitions, gates',
    lifetime: 30,
  },
  '56': {
    code: '56',
    name: '',
  },
  '57': {
    code: '57',
    name: '',
  },
  '58': {
    code: '58',
    name: 'External wall completions',
    lifetime: 30,
  },
  '59': {
    code: '59',
    name: '',
  },
  '6': {
    code: '6',
    name: 'Partitions, completions',
    lifetime: 30,
  },
  '60': {
    code: '60',
    name: 'Combined',
    lifetime: 30,
  },
  '61': {
    code: '61',
    name: 'Inner face of external wall',
    lifetime: 30,
  },
  '62': {
    code: '62',
    name: 'Subfloors',
    lifetime: 30,
  },
  '63': {
    code: '63',
    name: 'Internal walls',
    lifetime: 30,
  },
  '64': {
    code: '64',
    name: 'Ceilings',
    lifetime: 30,
  },
  '65': {
    code: '65',
    name: 'Internal doors, glazed partitions',
    lifetime: 30,
  },
  '66': {
    code: '66',
    name: 'Internal stairs',
    lifetime: 30,
  },
  '67': {
    code: '67',
    name: '',
  },
  '68': {
    code: '68',
    name: 'Room-forming completions',
    lifetime: 30,
  },
  '69': {
    code: '69',
    name: 'Other room formation',
    lifetime: 30,
  },
  '7': {
    code: '7',
    name: 'Interior finishes',
    lifetime: 10,
  },
  '70': {
    code: '70',
    name: 'Interior finishes - Composite',
    lifetime: 10,
  },
  '71': {
    code: '71',
    name: '',
  },
  '72': {
    code: '72',
    name: 'Floor, stair finishes',
    lifetime: 10,
  },
  '73': {
    code: '73',
    name: 'Wall finishes',
    lifetime: 10,
  },
  '74': {
    code: '74',
    name: 'Ceiling finishes, suspended ceilings',
    lifetime: 10,
  },
  '75': {
    code: '75',
    name: 'Painting',
    lifetime: 10,
  },
  '76': {
    code: '76',
    name: 'Appliances',
    lifetime: 10,
  },
  '77': {
    code: '77',
    name: 'Cabinetery',
    lifetime: 10,
  },
  '78': {
    code: '78',
    name: 'Interior fittings',
    lifetime: 10,
  },
  '79': {
    code: '79',
    name: 'Other interior fittings',
    lifetime: 10,
  },
  '8': {
    code: '8',
    name: 'Installations',
  },
  '80': {
    code: '80',
    name: 'Combined',
  },
  '81': {
    code: '81',
    name: 'Integrated solar cells',
    lifetime: 30,
  },
  '82': {
    code: '82',
    name: 'Process systems',
    lifetime: 25,
  },
  '83': {
    code: '83',
    name: 'Large kitchen',
  },
  '84': {
    code: '84',
    name: 'Plumbing, heating',
    lifetime: 20,
  },
  '85': {
    code: '85',
    name: 'Cooling, ventilation',
    lifetime: 15,
  },
  '86': {
    code: '86',
    name: 'Electrical',
    lifetime: 15,
  },
  '87': {
    code: '87',
    name: 'Transportation',
    lifetime: 20,
  },
  '88': {
    code: '88',
    name: 'Control, regulation',
    lifetime: 15,
  },
  '89': {
    code: '89',
    name: 'Other installations',
  },
  '9': {
    code: '9',
    name: 'Site operations',
  },
  '90': {
    code: '90',
    name: 'General works',
  },
  '91': {
    code: '91',
    name: '',
  },
  '92': {
    code: '92',
    name: '',
  },
  '93': {
    code: '93',
    name: '',
  },
  '94': {
    code: '94',
    name: '',
  },
  '95': {
    code: '95',
    name: '',
  },
  '96': {
    code: '96',
    name: '',
  },
  '97': {
    code: '97',
    name: '',
  },
  '98': {
    code: '98',
    name: '',
  },
  '99': {
    code: '99',
    name: '',
  },
  '101': {
    code: '101',
    name: 'A5.1: Waste, packaging and waste management',
  },
  '102': {
    code: '102',
    name: 'A5.2: Construction site vehicles, machinery and equipment',
    description: 'Energy for fuel etc.',
  },
  '103': {
    code: '103',
    name: 'A5.3: Temporary sheds, offices, warehouses and other buildings',
    description: 'Energy for heating etc.',
  },
  '104': {
    code: '104',
    name: 'A5.4: Other energy products of the construction process',
    description:
      'Such as propane and diesel for heaters and the like, purchased electricity, district heating, etc.',
  },
  '105': {
    code: '105',
    name: 'A5.5: Other environmental impact from the construction process',
    description:
      'Including eutrophication during blasting, land exploitation, chemical use, etc.',
  },
};

export const sbefCodesList = Object.freeze(
  Object.keys(sbefCodeRecord) as SbefCode[],
);

export const sbefCodesSet = Object.freeze(new Set<string>(sbefCodesList));
